module.exports = __webpack_public_path__ + "img/5.7b8e75e9.svg";